<div class="h-full min-h-0" *transloco="let t">
  <app-form-shell>
    <div shellHeader>
      <IStepper [steps]="formSteps()" [form]="audiencesCreationForm" (stepSelect)="goToStep($event)" clickable />
    </div>
    <div shellMain class="h-full min-h-0">
      @switch (currentStepId()) {
        @case ("name") {
          <div class="flex flex-col gap-6 py-8">
            <div class="flex flex-col gap-1">
              <h4>{{ t("dsp-create-audiences-page.choose_a_name") }}</h4>
            </div>
            <IFormField class="w-96">
              <label iLabel>{{ t("dsp-create-audiences-page.choose_a_base_name") }}</label>
              <input
                iInput
                [placeholder]="t('dsp-create-audiences-page.audience_name')"
                [formField]="audiencesCreationForm.name.audienceName"
                size="sm"
              />
            </IFormField>
          </div>
        }
        @case ("products") {
          <app-dsp-create-audience-products-step [products]="audiencesCreationForm.products" />
        }
        @case ("rules") {
          <app-dsp-create-audience-rules-step [rules]="audiencesCreationForm.rules" [preview]="rulesPreview()" />
        }
      }
    </div>
    <div shellFooter class="flex items-center justify-between gap-3">
      <button iButton variant="secondary" type="button" [disabled]="isCreatingAudiences()" (click)="cancel()">
        {{ t("common.cancel") }}
      </button>
      <div class="flex items-center gap-3">
        @if (isCreatingAudiences()) {
          <span class="type-label text-muted-foreground">
            {{ t("dsp-create-audiences-page.we_are_creating_your_audiences") }}
          </span>
        }
        @if (!isFirstStep()) {
          <button iButton variant="secondary" type="button" [disabled]="isCreatingAudiences()" (click)="back()">
            {{ t("common.back") }}
          </button>
        }
        <button iButton type="button" [disabled]="!canGoNext()" [loading]="isCreatingAudiences()" (click)="next()">
          {{
            isLastStep()
              ? isCreatingAudiences()
                ? t("dsp-create-audiences-page.creating_your_audiences")
                : t("dsp-create-audiences-page.create_n_audiences", {
                    count: audiencesCreationConfig().audiences?.length ?? 0,
                  })
              : t("common.next")
          }}
        </button>
      </div>
    </div>
  </app-form-shell>
</div>
